/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Hotel } from '@app/hotels/hotels/hotel.model';
import { HotelsSeoFormComponent } from '@app/hotels/hotels/hotels-seo-form/hotels-seo-form.component';

@Injectable({
  providedIn: 'root',
})
export class HotelsSeoFormService {
  constructor(private modalService: NgbModal) {}

  public open(hotel: null | Hotel = null): Promise<any> {
    const modal = this.modalService.open(HotelsSeoFormComponent, { size: 'xl' as 'lg' });
    modal.componentInstance.hotelSeo = hotel;
    return modal.result;
  }
}
